// 设备定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 设备类型
 */
class Type extends UltMeta {
    CAMERA = new Meta(1, "摄像头");
    GPS = new Meta(2, "GPS");
}

export const TYPE = new Type();

/**
 * 是否在线
 */
class Online extends UltMeta {
    OFFLINE = new Meta(0, "离线");
    ONLINE = new Meta(1, "在线");
}

export const ONLINE_STATUS = new Online();
